import * as types from '../../lib/actionTypes.es6';

export function getTaxConfigsRequest(partner) {
  return { type: types.GET_TAX_CONFIGS_REQUEST, payload: partner };
}
export function getTaxConfigsSuccess(configs) {
  return { type: types.GET_TAX_CONFIGS_SUCCESS, payload: configs };
}
export function getTaxConfigsFail(error) {
  return { type: types.GET_TAX_CONFIGS_FAIL, payload: error };
}

export function getTaxConfigRawRequest(partner, type) {
  return { type: types.GET_TAX_CONFIG_RAW_REQUEST, payload: { partner, type } };
}
export function getTaxConfigRawSuccess(raw) {
  return { type: types.GET_TAX_CONFIG_RAW_SUCCESS, payload: raw };
}
export function getTaxConfigRawFail(error) {
  return { type: types.GET_TAX_CONFIG_RAW_FAIL, payload: error };
}
export function getTaxConfigRawReset() {
  return { type: types.GET_TAX_CONFIG_RAW_RESET };
}

export function publishTaxConfigRequest(partner, type, rawYaml) {
  return { type: types.PUBLISH_TAX_CONFIG_REQUEST, payload: { partner, type, rawYaml } };
}
export function publishTaxConfigSuccess(result) {
  return { type: types.PUBLISH_TAX_CONFIG_SUCCESS, payload: result };
}
export function publishTaxConfigFail(error) {
  return { type: types.PUBLISH_TAX_CONFIG_FAIL, payload: error };
}
export function publishTaxConfigReset() {
  return { type: types.PUBLISH_TAX_CONFIG_RESET };
}

export function createTaxConfigRequest(partner, rawYaml) {
  return { type: types.CREATE_TAX_CONFIG_REQUEST, payload: { partner, rawYaml } };
}
export function createTaxConfigSuccess(result) {
  return { type: types.CREATE_TAX_CONFIG_SUCCESS, payload: result };
}
export function createTaxConfigFail(error) {
  return { type: types.CREATE_TAX_CONFIG_FAIL, payload: error };
}
export function createTaxConfigReset() {
  return { type: types.CREATE_TAX_CONFIG_RESET };
}
